var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c("div", { attrs: { id: "subheader" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "main-container" } }, [
        _c("div", { attrs: { id: "label-container" } }, [
          _c("span", { attrs: { id: "label" } }, [
            _vm._v(_vm._s(_vm.numeroPedido))
          ])
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c("div", { attrs: { id: "header-pedido" } }, [
            _c(
              "div",
              {
                staticClass: "fh rc",
                staticStyle: { width: "100%", height: "100%" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cb",
                    staticStyle: {
                      "font-size": "13px",
                      color: "#5D6770",
                      "margin-right": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "Subtotal: " +
                        _vm._s(_vm.moneyLabel) +
                        " " +
                        _vm._s(_vm._f("formatMoney")(_vm.subtotal)) +
                        " "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cb",
                    staticStyle: {
                      "font-size": "16px",
                      color: "#5D6770",
                      "margin-right": "36px",
                      "font-weight": "500"
                    }
                  },
                  [
                    _vm._v(
                      "Total: " +
                        _vm._s(_vm.moneyLabel) +
                        " " +
                        _vm._s(_vm._f("formatMoney")(_vm.total)) +
                        " "
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "list-container" } },
            _vm._l(_vm.productosComp, function(item) {
              return _c("item-pedido", {
                attrs: { id: "list-prod", item: item }
              })
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: { width: "630px", height: "7vh" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fv cr",
                  staticStyle: {
                    width: "50%",
                    height: "35px",
                    "font-size": "10px",
                    "font-weight": "500",
                    color: "#5D6770"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fh lb", staticStyle: { height: "50%" } },
                    [
                      _c("div", { staticStyle: { width: "105px" } }, [
                        _vm._v(" Fecha de Alta:")
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(this.splitFechaAlta))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "fh lc", staticStyle: { height: "50%" } },
                    [
                      _c("div", { staticStyle: { width: "105px" } }, [
                        _vm._v(" Fecha de Entrega:")
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(this.pedido.FechaEntrega))])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh rc",
                  staticStyle: { width: "50%", height: "35px" }
                },
                [
                  _c("input", {
                    attrs: {
                      id: "btnReplicar",
                      type: "submit",
                      value: "REPLICAR  PEDIDO"
                    },
                    on: { click: _vm.btnReplicar }
                  })
                ]
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66eee411", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66eee411","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/pedidoCms.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-66eee411","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/pedidoCms.vue
// module chunks = 0